import React from 'react'
import { connect } from 'react-redux'
import BlankBlock from './BlankBlock'
import DiscussionBlock from './DiscussionBlock'
import { CommentText } from './styles'
import Button from '../Button'
import * as R from 'ramda'
import { FillContainer } from '../Container/containers'
import styled from 'styled-components'

const Block = styled.div`
  margin: 12px auto;
  span {
    font-weight: 400;
    margin-bottom: 8px;
    display: inline-block;
  }
`

class LectureDiscussion extends React.Component {
  state = {
    comment: ''
  }
  render() {
    const {
      isAuthenticated,
      lectureDiscussions,
      onDiscussionCreate
    } = this.props
    const { comment } = this.state
    return (
      <FillContainer>
        {isAuthenticated ? (
          <Block>
            <span>對於講座還有不清楚的地方？留言問講師吧！</span>
            <CommentText
              placeholder="留言..."
              value={comment}
              onChange={e => this.setState({ comment: e.target.value })}
            />
            <Block>
              <div className="container-fluid">
                <div className="row justify-content-end">
                  <Button
                    disabled={!comment}
                    intent="primary"
                    onClick={() => {
                      this.setState({ comment: '' })
                      onDiscussionCreate(comment)
                    }}
                  >
                    留言
                  </Button>
                </div>
              </div>
            </Block>
          </Block>
        ) : (
          <Block>
            <span>
              對於活動還有不清楚的地方？<span>登入</span>留言問講師吧！
            </span>
          </Block>
        )}
        <Block>
          {lectureDiscussions.length ? (
            lectureDiscussions.map(discussion => (
              <DiscussionBlock key={discussion.id} discussion={discussion} />
            ))
          ) : (
            <BlankBlock />
          )}
        </Block>
      </FillContainer>
    )
  }
}

const mapState = ({ auth, lectureDiscussion }) => ({
  isAuthenticated: auth.isAuthenticated,
  lectureDiscussions: R.sortBy(discussion => -discussion.ts)(
    lectureDiscussion.entities
  )
})

const mapDispatch = dispatch => ({
  onDiscussionCreate: text => {
    dispatch.lectureDiscussion.createDiscussion({ text })
  }
})

export default connect(
  mapState,
  mapDispatch
)(LectureDiscussion)



// WEBPACK FOOTER //
// ./src/components/LectureComment/LectureDiscussion.js